import React from 'react';
import { translate } from 'react-i18next';
import ShopDetailsPage from '~/modules/ecommerceShops/containers/shopDetails/ShopDetailsPage';

const ShopDetails = () => <ShopDetailsPage />;

export default translate('ecommerceProducts')(ShopDetails);
